// «الجرد الشهري» strings (admin screens). Merged into translations by i18n.js.
// Keys are stk_*; both languages must carry the same key set.
// Board / panel / items / costs / setup screens: stk_board_*, stk_panel_*,
// stk_items_*, stk_costs_*, stk_setup_*, plus shared words as stk_admin_*.
// Templates use {name} tokens, filled with scUtils.fmt().
export const STK_ADMIN = {
    ar: {
        // ---- shared
        stk_admin_active: "نشط",
        stk_admin_inactive: "غير نشط",
        stk_admin_cancel: "إلغاء",
        stk_admin_close: "إغلاق",
        stk_admin_save: "حفظ",
        stk_admin_saving: "جارٍ الحفظ…",
        stk_admin_offline_error: "تعذر الاتصال بالخادم. تحقق من الشبكة وحاول مرة أخرى",
        stk_admin_retry: "إعادة المحاولة",
        stk_admin_reason: "السبب",
        stk_admin_reason_hint: "اكتب سبباً واضحاً؛ يُحفظ في سجل الجرد.",
        stk_admin_reason_min: "٥ أحرف على الأقل",

        // ---- board «لوحة الجرد»
        stk_board_window: "فترة الجرد",
        stk_board_cost_sets: "التكلفة من ملفات",
        stk_board_no_cost_sets: "لا يوجد ملف تكاليف لهذا الشهر",
        stk_board_kind_all: "كل المواقع",
        stk_board_total_locations: "المواقع",
        stk_board_total_value: "القيمة الإجمالية",
        stk_board_items_suffix: "صنف",
        stk_board_late: "متأخر",
        stk_board_inactive: "غير نشط",
        stk_board_updated: "آخر تحديث",
        stk_board_never: "لم يبدأ الجرد بعد",
        stk_board_open_until: "مفتوح حتى",
        stk_board_missing_cost: "{n} بلا تكلفة",
        stk_board_empty: "لا توجد مواقع لهذا الشهر",
        stk_board_export: "تصدير Excel",
        stk_board_exporting: "جارٍ التصدير…",
        stk_board_exported: "تم تنزيل الملف",
        stk_board_export_failed: "تعذر تصدير الملف",

        // ---- sheet panel
        stk_panel_title: "ورقة الجرد",
        stk_panel_counted: "المجرود",
        stk_panel_value: "القيمة",
        stk_panel_missing_cost: "بلا تكلفة",
        stk_panel_no_cost: "بلا تكلفة",
        stk_panel_snapshot_note: "القيم مثبّتة من لحظة الاعتماد ولا تتغير برفع تكاليف جديدة.",
        stk_panel_lines: "الأصناف المجرودة",
        stk_panel_uncounted: "{n} بلا جرد",
        stk_panel_no_lines: "لم يُجرد أي صنف بعد",
        stk_panel_history: "السجل",
        stk_panel_field_kind: "النوع",
        stk_panel_field_erp_store: "مستودع ERP",
        stk_panel_field_window: "فترة الجرد",
        stk_panel_field_open_until: "مفتوح حتى",
        stk_panel_field_updated: "آخر تعديل",
        stk_panel_field_submitted: "الإرسال",
        stk_panel_field_approved: "الاعتماد",
        stk_panel_action_submit: "إرسال الجرد",
        stk_panel_action_reopen: "إعادة فتح",
        stk_panel_action_approve: "اعتماد",
        stk_panel_action_unapprove: "إلغاء الاعتماد",
        stk_panel_action_zero_fill: "اعتبار غير المجرود صفراً",
        stk_panel_edit: "تعديل",
        stk_panel_approve: "اعتماد الجرد",
        stk_panel_approved: "تم اعتماد الجرد",
        stk_panel_unapprove: "إلغاء الاعتماد",
        stk_panel_unapprove_title: "إلغاء اعتماد الجرد",
        stk_panel_unapprove_body: "يعود الجرد إلى «تم الإرسال» وتُحذف القيم المثبّتة. اكتب السبب.",
        stk_panel_unapproved: "تم إلغاء الاعتماد",
        stk_panel_reopen: "إعادة فتح الجرد",
        stk_panel_reopen_title: "إعادة فتح الجرد",
        stk_panel_reopen_body: "يعود الجرد إلى «قيد الجرد»، ويستطيع المسؤول عن الموقع التعديل والإرسال حتى التاريخ المحدد.",
        stk_panel_reopen_until: "مفتوح حتى (آخر يوم)",
        stk_panel_reopen_until_hint: "من اليوم وحتى {max}",
        stk_panel_reopened: "تمت إعادة فتح الجرد",
        stk_panel_close: "إغلاق",

        // ---- items «الأصناف»
        stk_items_search: "ابحث بالاسم أو الكود",
        stk_items_all_groups: "كل المجموعات",
        stk_items_show_inactive: "إظهار غير النشطة",
        stk_items_count: "الأصناف النشطة",
        stk_items_add: "إضافة صنف",
        stk_items_edit: "تعديل الصنف",
        stk_items_empty: "لا توجد أصناف مطابقة",
        stk_items_code: "الكود",
        stk_items_erp_code: "كود ERP",
        stk_items_name: "الصنف",
        stk_items_name_ar: "الاسم بالعربي",
        stk_items_name_en: "الاسم بالإنجليزي",
        stk_items_group: "المجموعة",
        stk_items_kinds: "يُجرد في",
        stk_items_unit: "وحدة الجرد",
        stk_items_pack: "العبوة",
        stk_items_cost: "تكلفة يدوية",
        stk_items_active: "الحالة",
        stk_items_dialog_hint: "الحقول المعلّمة بـ * مطلوبة.",
        stk_items_section_count: "طريقة العد",
        stk_items_count_unit: "وحدة الجرد",
        stk_items_allows_decimal: "الكسور العشرية",
        stk_items_decimal_yes: "مسموحة (مثل ١٫٥)",
        stk_items_decimal_no: "أرقام صحيحة فقط",
        stk_items_pack_unit: "وحدة العبوة",
        stk_items_pack_unit_ph: "مثل: كرتون",
        stk_items_pack_size: "عدد الوحدات في العبوة",
        stk_items_pack_hint: "عند تحديد عبوة يُدخل الجارد عدد العبوات الكاملة والمفتوح، ويُحوَّل المجموع إلى وحدة الجرد.",
        stk_items_section_cost: "التكلفة",
        stk_items_manual_cost: "تكلفة يدوية لوحدة الجرد",
        stk_items_manual_cost_hint: "تُستخدم بدلاً من تكلفة ERP عند تعبئتها. اتركها فارغة لاستخدام ملف التكاليف.",
        stk_items_cost_unit: "وحدة التكلفة في ERP",
        stk_items_cost_unit_size: "وحدات جرد في وحدة ERP",
        stk_items_cost_unit_hint: "اختياري: عندما تختلف وحدة ERP عن وحدة الجرد، مثل «كرتون» في ERP = ١٢ حبة في الجرد.",
        stk_items_sort_order: "الترتيب",
        stk_items_note: "ملاحظة",
        stk_items_saved: "تم حفظ الصنف",
        stk_items_no_changes: "لا توجد تغييرات",
        stk_items_fix_fields: "صحّح الحقول المعلّمة",
        stk_items_err_required: "مطلوب",
        stk_items_err_kinds: "اختر نوع موقع واحداً على الأقل",
        stk_items_err_pack_size: "أكبر من ١ وحتى ١٠٠٬٠٠٠",
        stk_items_err_cost: "تكلفة غير صحيحة",
        stk_items_err_cost_unit_size: "أكبر من صفر",

        // ---- costs «التكاليف»
        stk_costs_sets_title: "ملفات التكاليف",
        stk_costs_sets_hint: "تكاليف الأصناف من تقرير «بطاقة حركة صنف» في ERP، ملف لكل شهر",
        stk_costs_sets_empty: "لم يُرفع أي ملف تكاليف بعد",
        stk_costs_upload: "رفع ملف التكاليف",
        stk_costs_as_of: "حتى تاريخ",
        stk_costs_source_seed: "مُعدّ مسبقاً",
        stk_costs_source_upload: "مرفوع",
        stk_costs_superseded: "مُستبدَل",
        stk_costs_deactivate: "إيقاف",
        stk_costs_deactivate_title: "إيقاف ملف التكاليف؟",
        stk_costs_deactivate_body: "لن تُستخدم تكاليف {period} من هذا الملف في التقييم. الجرد المعتمد لا يتأثر.",
        stk_costs_deactivated: "تم إيقاف ملف التكاليف",
        stk_costs_coverage_title: "تغطية التكاليف",
        stk_costs_coverage_hint: "الأصناف النشطة التي لها تكلفة في هذا الشهر، والأصناف بلا تكلفة",
        stk_costs_with_cost: "لها تكلفة",
        stk_costs_without_cost: "بلا تكلفة",
        stk_costs_missing_title: "أصناف بلا تكلفة",
        stk_costs_no_erp_code: "بلا كود ERP",
        stk_costs_all_covered: "كل الأصناف النشطة لها تكلفة",
        stk_costs_item_missing: "الصنف غير موجود",
        stk_costs_upload_title: "رفع ملف التكاليف",
        stk_costs_upload_body: "صدّر تقرير «بطاقة حركة صنف» من ERP حتى نهاية الشهر وارفعه هنا. يمكن رفع أكثر من ملف للشهر نفسه ثم اعتمادها معاً.",
        stk_costs_choose: "اختر الملفات أو اسحبها هنا",
        stk_costs_choose_hint: "حتى {n} ملفات",
        stk_costs_wrong_type: "نوع الملف غير مدعوم. ارفع ملف xls أو html المصدَّر من ERP",
        stk_costs_max_files: "الحد {n} ملفات في المرة الواحدة",
        stk_costs_remove_file: "إزالة الملف",
        stk_costs_status_queued: "في الانتظار",
        stk_costs_status_compressing: "جارٍ ضغط الملف…",
        stk_costs_status_uploading: "جارٍ الرفع والقراءة…",
        stk_costs_file_rows: "{n} حركة",
        stk_costs_file_items: "{n} صنف",
        stk_costs_file_skipped: "تم تجاهل {n} سطر",
        stk_costs_file_too_large: "الملف أكبر من ٢٥ ميجابايت",
        stk_costs_upload_failed: "تعذر رفع الملف",
        stk_costs_will_be_for: "ستُعتمد كتكاليف {period}",
        stk_costs_note: "ملاحظة (اختياري)",
        stk_costs_commit: "اعتماد",
        stk_costs_committed: "تم اعتماد ملف التكاليف",
        stk_costs_committed_for: "تم اعتماد تكاليف {period}",

        // ---- setup «الإعداد»
        stk_setup_locations_title: "مواقع الجرد",
        stk_setup_locations_hint: "اسم مستودع ERP لكل موقع يظهر في ملف الإدخال. الموقع غير النشط لا يُجرد.",
        stk_setup_erp_store: "مستودع ERP",
        stk_setup_location_saved: "تم حفظ الموقع",
        stk_setup_no_locations: "لا توجد مواقع",
        stk_setup_settings_title: "إعدادات الجرد",
        stk_setup_settings_hint: "تسري على كل المواقع",
        stk_setup_settings_saved: "تم حفظ الإعدادات",
        stk_setup_err_range: "أدخل رقماً من {min} إلى {max}",
        stk_setup_open_days_before_end: "أيام الجرد قبل نهاية الشهر",
        stk_setup_open_days_before_end_hint: "١ = تفتح الفترة في آخر يوم من الشهر",
        stk_setup_close_days_after: "أيام الجرد في الشهر التالي",
        stk_setup_close_days_after_hint: "٢ = تُغلق بنهاية اليوم الثاني من الشهر التالي",
        stk_setup_reopen_max_days: "أقصى مدة لإعادة الفتح (أيام)",
        stk_setup_reopen_max_days_hint: "أبعد تاريخ تستطيع المالية فتح الجرد حتى",
        stk_setup_max_quantity: "أقصى كمية للسطر",
        stk_setup_max_quantity_hint: "بوحدة الجرد",
        stk_setup_show_values_to_counters: "إظهار القيم للجارد",
        stk_setup_show_values_to_counters_hint: "يرى مدير الفرع وجارد المستودع قيمة الجرد بالريال",
    },
    en: {
        // ---- shared
        stk_admin_active: "Active",
        stk_admin_inactive: "Inactive",
        stk_admin_cancel: "Cancel",
        stk_admin_close: "Close",
        stk_admin_save: "Save",
        stk_admin_saving: "Saving…",
        stk_admin_offline_error: "Could not reach the server. Check the connection and try again",
        stk_admin_retry: "Retry",
        stk_admin_reason: "Reason",
        stk_admin_reason_hint: "Write a clear reason; it is kept in the count's history.",
        stk_admin_reason_min: "At least 5 characters",

        // ---- board
        stk_board_window: "Count window",
        stk_board_cost_sets: "Costs from",
        stk_board_no_cost_sets: "No cost file for this month",
        stk_board_kind_all: "All locations",
        stk_board_total_locations: "Locations",
        stk_board_total_value: "Total value",
        stk_board_items_suffix: "items",
        stk_board_late: "Late",
        stk_board_inactive: "Inactive",
        stk_board_updated: "Updated",
        stk_board_never: "Not started yet",
        stk_board_open_until: "Open until",
        stk_board_missing_cost: "{n} without cost",
        stk_board_empty: "No locations for this month",
        stk_board_export: "Export Excel",
        stk_board_exporting: "Exporting…",
        stk_board_exported: "File downloaded",
        stk_board_export_failed: "Could not export the file",

        // ---- sheet panel
        stk_panel_title: "Count sheet",
        stk_panel_counted: "Counted",
        stk_panel_value: "Value",
        stk_panel_missing_cost: "No cost",
        stk_panel_no_cost: "No cost",
        stk_panel_snapshot_note: "Values are frozen at approval and do not change when new costs are uploaded.",
        stk_panel_lines: "Counted items",
        stk_panel_uncounted: "{n} not counted",
        stk_panel_no_lines: "Nothing has been counted yet",
        stk_panel_history: "History",
        stk_panel_field_kind: "Type",
        stk_panel_field_erp_store: "ERP store",
        stk_panel_field_window: "Count window",
        stk_panel_field_open_until: "Open until",
        stk_panel_field_updated: "Last edit",
        stk_panel_field_submitted: "Submitted",
        stk_panel_field_approved: "Approved",
        stk_panel_action_submit: "Submitted",
        stk_panel_action_reopen: "Reopened",
        stk_panel_action_approve: "Approved",
        stk_panel_action_unapprove: "Unapproved",
        stk_panel_action_zero_fill: "Uncounted items set to zero",
        stk_panel_edit: "Edit",
        stk_panel_approve: "Approve count",
        stk_panel_approved: "Count approved",
        stk_panel_unapprove: "Unapprove",
        stk_panel_unapprove_title: "Unapprove the count",
        stk_panel_unapprove_body: "The count goes back to «Submitted» and its frozen values are cleared. Enter the reason.",
        stk_panel_unapproved: "Approval removed",
        stk_panel_reopen: "Reopen count",
        stk_panel_reopen_title: "Reopen the count",
        stk_panel_reopen_body: "The count goes back to «In progress»; the location's counter can edit and submit until the chosen date.",
        stk_panel_reopen_until: "Open until (last day)",
        stk_panel_reopen_until_hint: "From today up to {max}",
        stk_panel_reopened: "Count reopened",
        stk_panel_close: "Close",

        // ---- items
        stk_items_search: "Search by name or code",
        stk_items_all_groups: "All groups",
        stk_items_show_inactive: "Show inactive",
        stk_items_count: "Active items",
        stk_items_add: "Add item",
        stk_items_edit: "Edit item",
        stk_items_empty: "No matching items",
        stk_items_code: "Code",
        stk_items_erp_code: "ERP code",
        stk_items_name: "Item",
        stk_items_name_ar: "Arabic name",
        stk_items_name_en: "English name",
        stk_items_group: "Group",
        stk_items_kinds: "Counted at",
        stk_items_unit: "Count unit",
        stk_items_pack: "Pack",
        stk_items_cost: "Manual cost",
        stk_items_active: "Status",
        stk_items_dialog_hint: "Fields marked * are required.",
        stk_items_section_count: "How it is counted",
        stk_items_count_unit: "Count unit",
        stk_items_allows_decimal: "Decimals",
        stk_items_decimal_yes: "Allowed (e.g. 1.5)",
        stk_items_decimal_no: "Whole numbers only",
        stk_items_pack_unit: "Pack unit",
        stk_items_pack_unit_ph: "e.g. carton",
        stk_items_pack_size: "Units per pack",
        stk_items_pack_hint: "With a pack set, the counter enters whole packs plus loose units, and the total is converted to the count unit.",
        stk_items_section_cost: "Cost",
        stk_items_manual_cost: "Manual cost per count unit",
        stk_items_manual_cost_hint: "Used instead of the ERP cost when filled. Leave it empty to use the cost file.",
        stk_items_cost_unit: "ERP cost unit",
        stk_items_cost_unit_size: "Count units per ERP unit",
        stk_items_cost_unit_hint: "Optional: when the ERP unit differs from the count unit, e.g. a «carton» in ERP = 12 pieces counted.",
        stk_items_sort_order: "Sort order",
        stk_items_note: "Note",
        stk_items_saved: "Item saved",
        stk_items_no_changes: "No changes",
        stk_items_fix_fields: "Fix the highlighted fields",
        stk_items_err_required: "Required",
        stk_items_err_kinds: "Pick at least one location type",
        stk_items_err_pack_size: "More than 1, up to 100,000",
        stk_items_err_cost: "Invalid cost",
        stk_items_err_cost_unit_size: "More than zero",

        // ---- costs
        stk_costs_sets_title: "Cost files",
        stk_costs_sets_hint: "Item costs from the ERP «Item Movement Card» report, one file per month",
        stk_costs_sets_empty: "No cost file has been uploaded yet",
        stk_costs_upload: "Upload cost file",
        stk_costs_as_of: "As of",
        stk_costs_source_seed: "Pre-loaded",
        stk_costs_source_upload: "Uploaded",
        stk_costs_superseded: "Superseded",
        stk_costs_deactivate: "Deactivate",
        stk_costs_deactivate_title: "Deactivate this cost file?",
        stk_costs_deactivate_body: "The {period} costs from this file will no longer be used for valuation. Approved counts are not affected.",
        stk_costs_deactivated: "Cost file deactivated",
        stk_costs_coverage_title: "Cost coverage",
        stk_costs_coverage_hint: "Active items with a cost for this month, and the items without one",
        stk_costs_with_cost: "With cost",
        stk_costs_without_cost: "Without cost",
        stk_costs_missing_title: "Items without a cost",
        stk_costs_no_erp_code: "no ERP code",
        stk_costs_all_covered: "Every active item has a cost",
        stk_costs_item_missing: "Item not found",
        stk_costs_upload_title: "Upload cost file",
        stk_costs_upload_body: "Export the ERP «Item Movement Card» report up to the month's end and upload it here. Several files for the same month can be uploaded and approved together.",
        stk_costs_choose: "Choose files or drop them here",
        stk_costs_choose_hint: "Up to {n} files",
        stk_costs_wrong_type: "Unsupported file. Upload the xls or html file exported from the ERP",
        stk_costs_max_files: "At most {n} files at a time",
        stk_costs_remove_file: "Remove file",
        stk_costs_status_queued: "Waiting",
        stk_costs_status_compressing: "Compressing…",
        stk_costs_status_uploading: "Uploading and reading…",
        stk_costs_file_rows: "{n} movements",
        stk_costs_file_items: "{n} items",
        stk_costs_file_skipped: "{n} rows skipped",
        stk_costs_file_too_large: "The file is larger than 25 MB",
        stk_costs_upload_failed: "Could not upload the file",
        stk_costs_will_be_for: "Will be approved as the {period} costs",
        stk_costs_note: "Note (optional)",
        stk_costs_commit: "Approve",
        stk_costs_committed: "Cost file approved",
        stk_costs_committed_for: "{period} costs approved",

        // ---- setup
        stk_setup_locations_title: "Count locations",
        stk_setup_locations_hint: "Each location's ERP store name appears in the ERP entry sheet. An inactive location is not counted.",
        stk_setup_erp_store: "ERP store",
        stk_setup_location_saved: "Location saved",
        stk_setup_no_locations: "No locations",
        stk_setup_settings_title: "Count settings",
        stk_setup_settings_hint: "Apply to every location",
        stk_setup_settings_saved: "Settings saved",
        stk_setup_err_range: "Enter a number from {min} to {max}",
        stk_setup_open_days_before_end: "Count days before month end",
        stk_setup_open_days_before_end_hint: "1 = the window opens on the month's last day",
        stk_setup_close_days_after: "Count days in the next month",
        stk_setup_close_days_after_hint: "2 = it closes at the end of day 2 of the next month",
        stk_setup_reopen_max_days: "Longest reopen (days)",
        stk_setup_reopen_max_days_hint: "How far ahead finance may reopen a count",
        stk_setup_max_quantity: "Largest quantity per line",
        stk_setup_max_quantity_hint: "In the count unit",
        stk_setup_show_values_to_counters: "Show values to counters",
        stk_setup_show_values_to_counters_hint: "Branch managers and warehouse counters see the count's value in riyals",
    },
};
